var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4697 1.46967C11.7626 1.17678 12.2374 1.17678 12.5303 1.46967L18.5303 7.46967C18.8232 7.76256 18.8232 8.23744 18.5303 8.53033C18.2374 8.82322 17.7626 8.82322 17.4697 8.53033L12.75 3.81066V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V3.81066L6.53033 8.53033C6.23744 8.82322 5.76256 8.82322 5.46967 8.53033C5.17678 8.23744 5.17678 7.76256 5.46967 7.46967L11.4697 1.46967ZM3 15.25C3.41421 15.25 3.75 15.5858 3.75 16V21C3.75 21.1381 3.86193 21.25 4 21.25H20C20.1381 21.25 20.25 21.1381 20.25 21V16C20.25 15.5858 20.5858 15.25 21 15.25C21.4142 15.25 21.75 15.5858 21.75 16V21C21.75 21.9665 20.9665 22.75 20 22.75H4C3.0335 22.75 2.25 21.9665 2.25 21V16C2.25 15.5858 2.58579 15.25 3 15.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bba430e03ed714a6aca5c5c3ade1903d.svg";
export { ForwardRef as ReactComponent };